import React, { Component } from "react";
import { Box } from "@mui/material";
import RevaText from "./RevaText";

class IconEmptyPage extends Component {
  render() {
    return (
      <Box sx={{ textAlign: "center", my: 10 }}>
        <img alt="placeholder" src="/img/no-data.svg" style={{ height: "20vh", marginBottom: 20 }} />
        {/* `text` is already translated by callers; do not pass it as RevaText `id`
            or formatjs will look up the locale string as a message key. */}
        <RevaText variant="h3" color="text.secondary">
          {this.props.text}
        </RevaText>
      </Box>
    );
  }
}

export default IconEmptyPage;
